import { Component, HostListener, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { IUser } from '../shared/models/auth.model';
import { AuthService } from '../shared/services/auth.service';
import { ThemeName, ThemeService } from '../shared/services/theme.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  isCollapsed = false;
  dot = true;

  constructor(
    private auth: AuthService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.auth.getInfo()
      .pipe(take(1))
      .subscribe((user: IUser) => {
        this.themeService.selectThemeByName(user.theme as ThemeName);
      });
  }
}
